/**
 * Filters slick slider based on product options.
 * 
 * - For color and size positions (vice-versa scenario: switch option values):
 *   - If data-filterid is present in main-product.liquid, pass Current Variant Id to newtest.
 *   - If not present, pass Current Variant Option values to newtest.
 * 
 * - For Size and Thickness positions (vice-versa scenario: switch option values):
 *   - If data-filterid is present in main-product.liquid, pass Current Variant Id to newtest.
 *   - If not present, pass Current Variant Option values to newtest.
 * 
 * - Else scenario:
 *   - Extract data-filter data attribute value from main-product.liquid.
 *   - Pass it to newtest function.
 **/

class SlickComponent extends HTMLElement {
  constructor() {
      super();
      this.sliderFor = $(this).find(".slider-for");
      this.sliderNav = $(this).find(".slider-nav");
      this.initSlick = this.initSlick.bind(this);
      this.newtest = this.newtest.bind(this);
      this.filterSlick = this.filterSlick.bind(this);
      this.initSlick();
      this.showSlide();
      document
          .querySelector("#trigger_swatchchange")
          .addEventListener("change", (e) => {
              this.filterSlick();
          });
  }

  filterSlick() {

      var swatch = $(this)
          .closest("[data-more-view-product]")
          .next(".product__info-wrapper.grid__item")
          .find("variant-radios");

      var optionDetails = $(".option-details");
      var colorPosition = optionDetails.data("colorposition");
      var sizePosition = optionDetails.data("sizeposition");
      var thicknessPosition = optionDetails.data("thicknessposition");
      var materialposition = optionDetails.data("materialposition"); 

      var inputChecked = swatch.find("input[type='radio']:checked");
      try {
          if (colorPosition == 1 && sizePosition == 2) {
              var colorInput = inputChecked.filter("[name='color']");
              var filterIdCheck = colorInput.data("filterid");

              if (filterIdCheck) {
                  var slickElement = document.querySelector('#trigger_swatchchange')
                  var currentVariant = slickElement.getAttribute("data-current_variant");
                  var currentVariantObj = JSON.parse(currentVariant)
                  var combinedFilterVal = `.filter-${currentVariantObj.id}`; // passing current variant ID
                  this.newtest(combinedFilterVal);
              } else {
                  var slickElement = document.querySelector('#trigger_swatchchange')
                  var currentVariant = slickElement.getAttribute("data-current_variant");
                  var currentVariantObj = JSON.parse(currentVariant)
                  var combinedFilterVal = `.filter-${currentVariantObj.option1}-${currentVariantObj.option2}`; // passing current variant Option values 
                  var formattedFilterVal = combinedFilterVal.replace(/[\s/]/g, '-').replace(/[""]/g, '').toLowerCase(); // regex to remove special characters
                  this.newtest(formattedFilterVal);
              }
          } else if (colorPosition == 2 && sizePosition == 1) {
              var colorInput = inputChecked.filter("[name='color']");
              var filterIdCheck = colorInput.data("filterid");

              if (filterIdCheck) {
                  var slickElement = document.querySelector('#trigger_swatchchange')
                  var currentVariant = slickElement.getAttribute("data-current_variant");
                  var currentVariantObj = JSON.parse(currentVariant)
                  var combinedFilterVal = `.filter-${currentVariantObj.id}`; // passing current variant ID
                  this.newtest(combinedFilterVal);
              } else {
                  var slickElement = document.querySelector('#trigger_swatchchange')
                  var currentVariant = slickElement.getAttribute("data-current_variant");
                  var currentVariantObj = JSON.parse(currentVariant)
                  var combinedFilterVal = `.filter-${currentVariantObj.option2}-${currentVariantObj.option1}`; // passing current variant Option values (Vice versa)
                  var formattedFilterVal = combinedFilterVal.replace(/[\s/]/g, '-').replace(/[""]/g, '').toLowerCase(); // regex to remove special characters
                  this.newtest(formattedFilterVal);
              }
          } else if (sizePosition == 1 && thicknessPosition == 2) {
              var sizeInput = inputChecked.filter("[name='size']");
              var filterIdCheck = sizeInput.data("filterid");

              if (filterIdCheck) {
                  var slickElement = document.querySelector('#trigger_swatchchange')
                  var currentVariant = slickElement.getAttribute("data-current_variant");
                  var currentVariantObj = JSON.parse(currentVariant)
                  var combinedFilterVal = `.filter-${currentVariantObj.id}`; // passing current variant ID
                  this.newtest(combinedFilterVal);
              } else {
                  var slickElement = document.querySelector('#trigger_swatchchange')
                  var currentVariant = slickElement.getAttribute("data-current_variant");
                  var currentVariantObj = JSON.parse(currentVariant)
                  var combinedFilterVal = `.filter-${currentVariantObj.option1}-${currentVariantObj.option2}`; // passing current variant Option values 
                  var formattedFilterVal = combinedFilterVal.replace(/[\s/]/g, '-').replace(/[""]/g, '').toLowerCase(); // regex to remove special characters
                  this.newtest(formattedFilterVal);
              }
          } else if (sizePosition == 2 && thicknessPosition == 1) {
              var sizeInput = inputChecked.filter("[name='size']");
              var filterIdCheck = sizeInput.data("filterid");

              if (filterIdCheck) {
                  var slickElement = document.querySelector('#trigger_swatchchange')
                  var currentVariant = slickElement.getAttribute("data-current_variant");
                  var currentVariantObj = JSON.parse(currentVariant)
                  var combinedFilterVal = `.filter-${currentVariantObj.id}`; // passing current variant ID
                  this.newtest(combinedFilterVal);
              } else {
                  var slickElement = document.querySelector('#trigger_swatchchange')
                  var currentVariant = slickElement.getAttribute("data-current_variant");
                  var currentVariantObj = JSON.parse(currentVariant)
                  var combinedFilterVal = `.filter-${currentVariantObj.option2}-${currentVariantObj.option1}`; // passing current variant Option values (Vice Versa)
                  var formattedFilterVal = combinedFilterVal.replace(/[\s/]/g, '-').replace(/[""]/g, '').toLowerCase(); // regex to remove special characters
                  this.newtest(formattedFilterVal);
              }
          }else if(materialposition == 1 && colorPosition == 2 ){
            var slickElement = document.querySelector('#trigger_swatchchange')
            var currentVariant = slickElement.getAttribute("data-current_variant");
            var currentVariantObj = JSON.parse(currentVariant)
            var combinedFilterVal = `.filter-${currentVariantObj.option1}-${currentVariantObj.option2}`; // passing current variant Option values (Vice Versa)
            var formattedFilterVal = combinedFilterVal.replace(/[\s/]/g, '-').replace(/[""]/g, '').toLowerCase(); // regex to remove special characters
            this.newtest(formattedFilterVal);
          } else if(materialposition == 2 && colorPosition == 1 ){         
            var slickElement = document.querySelector('#trigger_swatchchange')
            var currentVariant = slickElement.getAttribute("data-current_variant");
            var currentVariantObj = JSON.parse(currentVariant)
            var combinedFilterVal = `.filter-${currentVariantObj.option2}-${currentVariantObj.option1}`; // passing current variant Option values (Vice Versa)
            var formattedFilterVal = combinedFilterVal.replace(/[\s/]/g, '-').replace(/[""]/g, '').toLowerCase(); // regex to remove special characters
            this.newtest(formattedFilterVal);
          }
           else {
              var inputChecked = inputChecked.data("filter"); // Passing the checked input data-filter value
              this.newtest(inputChecked);
          }
      } catch (err) {
          console.error("Error occurred in filter combination", err);
      }
  }

  initZoom() {
      var win = $(window);
      var zoomElm = $("[data-more-view-product] [data-zoom]");
      if (win.width() >= 1200) {
          zoomElm.zoom();
      } else {
          zoomElm.trigger("zoom.destroy");
      }
  }

  initSlick() {
      var vertical = false;
      console.log("this.sliderFor", this.sliderFor[0]);
      console.log("this.sliderNav", this.sliderNav[0]);

      //if (this.sliderFor[0].not(".slick-initialized")) {
      this.sliderFor.slick({
          slidesToShow: this.sliderFor.data("imgs"),
          slidesToScroll: 1,
          arrows: false,
          vertical: false,
          fade: false,
          asNavFor: this.sliderNav,
          infinite: false,
          rows: 0,
          responsive: [{
              breakpoint: 1200,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  fade: true,
                  vertical: false,
              },
          }, ],
      });

      this.sliderNav.slick({
          infinite: true,
          slidesToShow: this.sliderNav.data("rows"),
          vertical: false,
          dots: false,
          slidesToShow: 6,
          centerMode: true,
          slidesToScroll: 1,
          asNavFor: this.sliderFor,
          focusOnSelect: true,
          arrows: true,
          centerMode: false,
          infinite: true,
          rows: 0,
          nextArrow: '<button type="button pro-left" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
          // '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" viewBox="0 0 17.205 38.205"><g id="Group_464" data-name="Group 464" transform="translate(36.403 581.103) rotate(180)"><line id="Line_59" data-name="Line 59" y1="17" x2="13" transform="translate(21.3 545)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/><line id="Line_60" data-name="Line 60" x2="13" y2="17" transform="translate(21.3 562)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/></g></svg></button>',

          prevArrow: '<button type="button pro-right" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="17.232" height="36.219" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
          // '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.232" height="36.219" viewBox="0 0 17.232 36.219"><g id="Group_606" data-name="Group 606" transform="translate(-19.184 -544.884)"><line id="Line_59" data-name="Line 59" y1="15" x2="13" transform="translate(21.3 547)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/><line id="Line_60" data-name="Line 60" x2="13" y2="17" transform="translate(21.3 562)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/></g></svg></button>',

          responsive: [{
                  breakpoint: 2600,
                  settings: {
                      slidesToShow: 6,
                      slidesToScroll: 1,
                      infinite: true,
                      nextArrow: '<button type="button pro-left" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
                      // '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" viewBox="0 0 17.205 38.205"><g id="Group_464" data-name="Group 464" transform="translate(36.403 581.103) rotate(180)"><line id="Line_59" data-name="Line 59" y1="17" x2="13" transform="translate(21.3 545)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/><line id="Line_60" data-name="Line 60" x2="13" y2="17" transform="translate(21.3 562)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/></g></svg></button>',

                      prevArrow: '<button type="button pro-right" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="17.232" height="36.219" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
                      get dots() {
                          if (vertical == true) {
                              return (dots = true);
                          }
                      },
                  },
              },
              {
                  breakpoint: 1200,
                  settings: {
                      slidesToShow: 6,
                      slidesToScroll: 1,
                      infinite: true,
                      nextArrow: '<button type="button pro-left" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
                      // '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" viewBox="0 0 17.205 38.205"><g id="Group_464" data-name="Group 464" transform="translate(36.403 581.103) rotate(180)"><line id="Line_59" data-name="Line 59" y1="17" x2="13" transform="translate(21.3 545)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/><line id="Line_60" data-name="Line 60" x2="13" y2="17" transform="translate(21.3 562)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/></g></svg></button>',

                      prevArrow: '<button type="button pro-right" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="17.232" height="36.219" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
                      get dots() {
                          if (vertical == true) {
                              return (dots = true);
                          }
                      },
                  },
              },
              {
                  breakpoint: 992,
                  settings: {
                      slidesToShow: 6,
                      slidesToScroll: 1,
                      infinite: true,
                      nextArrow: '<button type="button pro-left" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
                      // '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" viewBox="0 0 17.205 38.205"><g id="Group_464" data-name="Group 464" transform="translate(36.403 581.103) rotate(180)"><line id="Line_59" data-name="Line 59" y1="17" x2="13" transform="translate(21.3 545)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/><line id="Line_60" data-name="Line 60" x2="13" y2="17" transform="translate(21.3 562)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/></g></svg></button>',

                      prevArrow: '<button type="button pro-right" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="17.232" height="36.219" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
                      get dots() {
                          if (vertical == true) {
                              return (dots = true);
                          }
                      },
                  },
              },
              {
                  breakpoint: 768,
                  settings: {
                      slidesToShow: 6,
                      infinite: true,
                      slidesToScroll: 1,
                      nextArrow: '<button type="button pro-left" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
                      // '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" viewBox="0 0 17.205 38.205"><g id="Group_464" data-name="Group 464" transform="translate(36.403 581.103) rotate(180)"><line id="Line_59" data-name="Line 59" y1="17" x2="13" transform="translate(21.3 545)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/><line id="Line_60" data-name="Line 60" x2="13" y2="17" transform="translate(21.3 562)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/></g></svg></button>',

                      prevArrow: '<button type="button pro-right" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="17.232" height="36.219" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
                      get dots() {
                          if (vertical == true) {
                              return (dots = true);
                          }
                      },
                  },
              },
              {
                  breakpoint: 750,
                  settings: {
                      slidesToShow: 5,
                      infinite: true,
                      slidesToScroll: 1,
                      nextArrow: '<button type="button pro-left" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "/></g></g></g></svg></button>',
                      // '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="17.205" height="38.205" viewBox="0 0 17.205 38.205"><g id="Group_464" data-name="Group 464" transform="translate(36.403 581.103) rotate(180)"><line id="Line_59" data-name="Line 59" y1="17" x2="13" transform="translate(21.3 545)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/><line id="Line_60" data-name="Line 60" x2="13" y2="17" transform="translate(21.3 562)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="3"/></g></svg></button>',

                      prevArrow: '<button type="button pro-right" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="17.232" height="36.219" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"/></g></g></g></g></svg></button>',
                      get dots() {
                          if (vertical == true) {
                              return (dots = true);
                          }
                      },
                  },
              },
          ],
      });
      //}
      this.filterSlick();
  }

  showSlide() {
      var count = $(".slick-track").children().length;
      if (count < 6) {
          var slickthumb = $(".slick-track").children();
          slickthumb.removeClass("slick-active");
      }
  }

  newtest(inputChecked) {
      var className = inputChecked;
      if (className !== undefined) {
          console.log("className", className);
          this.sliderFor.slick("slickUnfilter");
          this.sliderFor.slick("slickFilter", className).slick("refresh");

          this.sliderNav.slick("slickUnfilter");
          this.sliderNav.slick("slickFilter", className).slick("refresh");
      }
      this.initZoom();
  }
}

customElements.define("slider-slick", SlickComponent);